import { DrawLogoProps } from "@interfaces/UploadInterfaces";

/**
 * DrawLogo component renders an SVG logo with a customizable stroke color.
 *
 * @param {string} [strokeColor="#e93d44"] - The color of the stroke for the SVG path.
 * @param {boolean} [animated=true] - Whether the logo should be animated.
 * @returns {JSX.Element} The rendered SVG logo.
 */
const DrawLogo = ({
  strokeColor = "#e93d44",
  animated = true,
}: DrawLogoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 13.449999809265137 169.14999389648438 34.95000076293945"
    data-asc="0.968"
    height={20}
  >
    <path
      className={animated ? "draw" : "static-draw"}
      stroke={strokeColor}
      fill="none"
      strokeWidth="1"
      pathLength="1"
      d="M49.15 46.25L49.15 48.40L38.40 48.40L38.40 21.10L26.20 45.35L22.90 45.35L10.75 21.10L10.75 48.40L0 48.40L0 46.25L4.85 46.25L4.85 13.45L14.05 13.45L24.60 35.40L35.15 13.45L44.30 13.45L44.30 46.25L49.15 46.25ZM91.10 46.25L91.10 48.40L79.95 48.40L76.45 40.45L58.95 40.45L55.45 48.40L44.30 48.40L44.30 46.25L50.10 46.25L64.55 13.45L70.85 13.45L85.30 46.25L91.10 46.25M74.05 35L67.70 20.60L61.35 35L74.05 35ZM128.20 46.25L128.20 48.40L117.05 48.40L113.55 40.45L96.05 40.45L92.55 48.40L81.40 48.40L81.40 46.25L87.20 46.25L101.65 13.45L107.95 13.45L122.40 46.25L128.20 46.25M111.15 35L104.80 20.60L98.45 35L111.15 35ZM128.20 46.25L128.20 13.45L134.10 13.45L134.10 46.25L138.95 46.25L138.95 48.40L123.35 48.40L123.35 46.25L128.20 46.25ZM169.15 46.25L169.15 48.40L138.95 48.40L138.95 46.25L151.10 46.25L151.10 18.85L140.50 18.85L140.50 13.45L167.60 13.45L167.60 18.85L157 18.85L157 46.25L169.15 46.25Z"
    />
  </svg>
);

export default DrawLogo;
